import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    token: localStorage.getItem('token'),
    pcNewlist:[]
  },
  getters:{
    isLogin: state => state.isLogin,
    pcNewlist:state=>state.pcNewlist,
    token: state => state.token,
  },
  mutations: {
    userStatus(state, value){
      state.isLogin = value.isLogin;
      state.token = value.token;
      localStorage.setItem('token', value.token);
    },
    changePcNewlistMut(state,params){
      state.pcNewlist = params
    }
  },
  actions: {
    userLogin({commit},flag){
      commit("userStatus", flag)
    },
    changePcNewlistAct({commit},params){
      commit("changePcNewlistMut", params)
    }
  },
  modules: {
  }
})
